import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { getUniqueId } from '../../../functions/get-unique-id';
import { CasePipe, CaseType } from '../../../pipes/case.pipe';
import { ExpandButtonComponent } from '../buttons/expand-button.component';
import { TagComponent, TagType } from '../labels/tag.component';

@Component({
  selector: 'app-panel',
  imports: [CommonModule, TagComponent, ExpandButtonComponent, CasePipe],
  template: `
    <div class="tw-w-full tw-overflow-hidden" [style.min-height]="minHeight">
      @if (label || headerTemplate || tag || showExpand) {
        <div
          class="tw-w-full tw-flex tw-flex-wrap tw-items-center tw-pt-3 tw-pb-1 x-tw-border-b-2 tw-border-[var(--sed-grey-40-color)]"
        >
          <div class="tw-grow tw-flex tw-items-left tw-items-center">
            @if (label) {
              <h2>
                {{ label | case: labelCase }}
              </h2>
            } @else {
              <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
            }
            @if (tag) {
              @if (tag === 'empty') {
                <span class="tw-pl-2 tw-text-[var(--sed-black-80-color)]"
                  ><i>Empty</i></span
                >
              } @else {
                <app-tag class="tw-pl-2" [type]="tagType">{{ tag }}</app-tag>
              }
            }
          </div>
          @if (showExpand) {
            <app-expand-button
              [expanded]="expanded"
              [parentId]="panelId"
              [label]="label"
              (expand)="expanded = $event"
            />
          }
        </div>
      }
      <div
        [id]="panelId"
        class="tw-w-full tw-pt-4 tw-pb-4 tw-px-1"
        [hidden]="showExpand && !expanded"
      >
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [``],
})
export class PanelComponent {
  @Input()
  label: string;

  @Input()
  labelTemplate: TemplateRef<any>;

  @Input()
  showExpand = false;

  @Input()
  expanded = true;

  @Input()
  minHeight: string = null;

  @ContentChild('header')
  headerTemplate: TemplateRef<any>;

  @Input()
  tag: string;

  @Input()
  tagType: TagType = 'Grey';

  @Input()
  labelCase: CaseType = 'sentence';

  protected panelId: string = getUniqueId('app-panel');
}
